import Vue from "vue";
import Router from "vue-router";
import fpTop from "./views/fpTop.vue";
import fpComplete from "./views/fpComplete.vue";
import fpDownloadPw from "./views/fpDownloadPw.vue";
import fpNotfound from "./views/fpNotfound.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "top-page",
      component: fpTop
    },
    {
      path: "/complete",
      name: "complete-page",
      component: fpComplete
    },
    {
      path: "/download/:id",
      name: "downloadpw-page",
      component: fpDownloadPw
    },
    {
      path: "*",
      name: "notfound-page",
      component: fpNotfound
    }
  ]
});
